<template>
  <Flex center :class="activeClasses">
    <slot />
  </Flex>
</template>

<script setup>
  import { computed } from 'vue'
  const props = defineProps({
    border: Boolean,
    space: Boolean,
    size: {
      type: String,
      default: 'size-8',
    },
  })

  const activeClasses = computed(() => {
    return [
      { 'p-1': props.space },
      { border: props.border },
      props.size,
      ' rounded-full',
    ]
  })
</script>
